module.exports = __webpack_public_path__ + "images/social-icons/apple-32-333c4b3c6c444378d762148b5713ac70.png";